"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureService = void 0;
const FeatureServiceLive_1 = require("./FeatureServiceLive");
const FeatureServiceStub_1 = require("./FeatureServiceStub");
class FeatureService {
    static create(stub) {
        if (stub) {
            return new FeatureServiceStub_1.FeatureServiceStub();
        }
        return new FeatureServiceLive_1.FeatureServiceLive();
    }
}
exports.FeatureService = FeatureService;
//# sourceMappingURL=FeatureService.js.map